module.exports = "<div class=\"c-auth-dialog-box__header\"\n  [style.background-color]='headerBackgroundColor'>\n  <img src=\"{{headerLogo}}\"/>\n</div>\n<div class=\"c-auth-dialog-box__body\">\n  <ng-content></ng-content>\n</div>\n<div class=\"c-auth-dialog-box__footer\">\n   <ng-content select=\"[footer]\"></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/auth-dialog-box/auth-dialog-box.component.html
// module id = ./src/app/modules/common-module/components/auth-dialog-box/auth-dialog-box.component.html
// module chunks = 9